import Form from 'Components/Forms/FormGenerator';
import FormViewer from 'Components/FormViewer';
import { actions as deviceActions } from 'ducks/devices';
import { sortBy } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { equipmentsByInProtocolId } from 'selectors/equipments';
import formSelectors from 'selectors/form';
import { metadataFields, serializeForm } from 'utils/forms/utils';
import validators from 'utils/forms/validators';
import { getDeviceMetadata } from 'utils/getMetadata.js';

const Component = props => {
    const { siteId, installationZones, parentDeviceId } = props;
    const { onSave } = props;

    const site = useSelector(state => state.sites.models[props.siteId]);
    const equipments = useSelector(state => equipmentsByInProtocolId(state, parentDeviceId));
    const formValues = useSelector(state => formSelectors.getFormValues(state));
    const submitting = useSelector(state => state.devices.submitting);
    const templatesUnfilter = useSelector(state => state.templates.models);

    const equipment = useSelector(state => state.equipments.models[formValues.equipment_id]);
    const rootDevice = useSelector(state => state.devices.models[state.devices.models[parentDeviceId]?.root_device_id]);
    const metadata = getDeviceMetadata(equipment, rootDevice);

    let
        organizationId = site.organization_id,
        templates = Object.values(templatesUnfilter).filter(template => template.organization_id === organizationId);

    const formSchema = [
        {
            formData: equipments.filter(equipment => equipment.usable),
            label: 'Equipment\x2a',
            name: 'equipment_id',
            type: 'select',
            validate: [validators.required]
        },
        {
            formData: sortBy(installationZones, 'full_path').map(({ id, full_path }) => ({ id, name: full_path })),
            label: 'Installation Zone\x2a',
            name: 'installation_zone_id',
            type: 'select',
            validate: [validators.required]
        }
    ];

    if (equipment?.licensing === false) {
        formSchema.push({
            label: 'Name\x2a',
            name: 'name',
            type: 'text',
            validate: [validators.required]
        });

        formSchema.push({
            label: 'Description',
            name: 'description',
            rows: 8,
            type: 'textArea'
        });

        formSchema.push({
            label: 'Integration?',
            name: 'integration',
            type: 'checkBox'
        });
    }

    formSchema.push(...metadataFields(metadata));

    if (equipment?.new_wise_box && templates.length) {
        formSchema.push({
            type: 'select',
            label: 'Template',
            name: 'template_id',
            formData: templates.map(({ id, name }) => ({ id, name }))
        });
    }

    const create = deviceActions.useCreate();
    const onSubmit = values => {
        let data = {
            ...serializeForm(values, formSchema, {}),
            ...{ site_id: siteId, parent_id: parentDeviceId }
        };

        create(data, onSave);
    };

    return (
        <FormViewer label="New device">
            <Form
                formSchema={formSchema}
                isSubmitting={submitting}
                onSubmit={onSubmit}
            />
        </FormViewer>
    );
};

export default Component;
